import template from './slider.component.html';
import angular from 'angular';
import './slider.repository';
import 'owl.carousel';

angular
    .module('Toke')
    .component('appSlider', {
        template,
        bindings: {
            data: '<'
        },
        controller: SliderController
    });

SliderController.$inject = ['sliderRepository', '$timeout'];

function SliderController(sliderRepository, $timeout) {

    const vm = this;
    vm.slider = [];

    vm.$onInit = function () {
        if (vm.data && vm.data.length) {
            vm.slider = vm.data;

            initOwl();
        } else {
            sliderRepository.getSlider().then(res => {
                vm.slider = res.data || [];

                initOwl();
            });
        }
    };

    function initOwl() {
        $timeout(() => {
            const $owl = angular.element('.banner-slider__carousel');

            if ($owl.length && !$owl.hasClass('owl-loaded')) {
                $owl.owlCarousel({
                    items: 1,
                    loop: false,
                    dots: true,
                    nav: false,
                    autoplay: false,
                    autoplayTimeout: 5000
                });
            }
        });
    }
}
